export default __webpack_public_path__ + "static/media/discover.b20f92ff.svg";